import React from "react"
import './index.css'
import { Link } from 'react-router-dom';
import { MenuPageSelect } from "../../Types/Types";

interface DDselectPageProp {
    updatePageName: Function,
    arrayPages: MenuPageSelect[],
    arrayLink: string[],
    currentLocation: string
}

const DDselectPage = ({updatePageName, arrayPages, arrayLink, currentLocation}: DDselectPageProp) => {
    const updateInfo = (value: MenuPageSelect, index: number) => {
        updatePageName({
            pageName: value.title,
            index: index
        })
    }

    return (
        <div className="selectPage-container">
            <ul className="selectPage-list">
                {
                    arrayPages.map((item, index) => (
                        <li key={index} 
                            className={currentLocation === arrayLink[index] ? 
                                "selectPage-item selected-item" : "selectPage-item"} 
                            onClick={() => updateInfo(item, index)}>
                            <Link to={arrayLink[index]} 
                                className='selectPage-link' >
                                <span key={index} 
                                    className="selectPage-svg">
                                        {arrayPages[index].img}
                                </span>
                                {item.title}
                            </Link>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default DDselectPage;